module.exports = __webpack_public_path__ + "img/stickers-avis-impots.22b1c499.jpg";